var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.656 18.208c-0.256 0-0.448-0.064-0.608-0.256-0.352-0.352-0.352-0.896 0-1.248l14.656-14.656c0.352-0.352 0.896-0.352 1.248 0s0.352 0.896 0 1.248l-14.656 14.656c-0.192 0.192-0.352 0.256-0.64 0.256zM20 30.208c-0.352 0-0.704-0.16-0.8-0.512l-5.152-11.648-11.744-5.248c-0.352-0.192-0.512-0.448-0.512-0.896 0-0.352 0.256-0.704 0.608-0.8l26.656-9.312c0.352-0.096 0.736 0 0.896 0.16 0.256 0.256 0.352 0.64 0.192 0.896l-9.344 26.656c-0.096 0.448-0.352 0.704-0.8 0.704 0 0 0 0 0 0zM5.056 12.096l9.952 4.448c0.192 0.064 0.384 0.256 0.448 0.448l4.448 9.952 8-22.848-22.848 8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.da2efb62bd719198445bfc858f6dfc9e.svg";
export { ForwardRef as ReactComponent };